/* eslint-disable no-throw-literal */
import Global from "../../commons/global";
import Helpers from "../../commons/helpers";
import { Constants } from "../../constants/constants";

export enum ContentType {
    JSON = "application/json",
    FORM = "application/x-www-form-urlencoded",
    FORM_DATA = "multipart/form-data",
}

export enum Method {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    PATCH = "PATCH",
}


export const HttpClient = (baseURL: string) => {
    let config: any = {
        baseURL,
        timeout: Constants.Api.TIMEOUT,
        headers: {
            // "Accept-Language": i18n?.language,
        },
    };

    const instance = Global.axios.create(config);

    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (!Helpers.isNullOrEmpty(error?.response)) {
                throw {
                    code: error?.response?.status,
                    message: error?.response?.data || "",
                };
            } else {
                throw {
                    code: error?.code,
                    message: error?.message,
                };
            }
        }
    );

    return instance;
};
